<template>
    <div>
        登入發生錯誤，身分驗證失敗。
    </div>
    <div
        v-if="errorMessage"
        class="mt-2"
    >
        {{ errorMessage }}
    </div>
</template>
<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();
const errorMessage = route.params?.errorMessage;
</script>
